import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const AtsResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { result } = location.state || {};

  useEffect(() => {
    if (!result) {
      navigate('/tools/ats');
    }
  }, [result, navigate]);

  if (!result) return null;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      <div className="flex-1 md:ml-64 p-8 flex flex-col items-center">
        <div className="w-full max-w-3xl">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800">ATS Check Results</h1>
            <button onClick={() => navigate('/tools/ats')} className="text-blue-600 hover:underline font-medium">← Check Another Resume</button>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-8 border-blue-600 mb-8">
            <div className="flex flex-col md:flex-row justify-between items-center mb-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">ATS Readiness</h2>
                <p className="text-gray-500">General resume quality and ATS friendliness.</p>
              </div>
              <div className={`mt-4 md:mt-0 text-6xl font-black ${result.score >= 70 ? 'text-green-500' : result.score >= 40 ? 'text-orange-500' : 'text-red-500'}`}>
                {result.score}%
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-green-600 mb-3 uppercase tracking-wider text-sm">Strengths</h3>
                <ul className="space-y-2">
                  {(result.strengths || []).map((item, i) => (
                    <li key={i} className="text-gray-700">• {item}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-red-500 mb-3 uppercase tracking-wider text-sm">Issues</h3>
                <ul className="space-y-2">
                  {(result.issues || []).map((item, i) => (
                    <li key={i} className="text-gray-700">• {item}</li>
                  ))}
                </ul>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h3 className="font-bold text-blue-700 mb-3 uppercase tracking-wider text-sm">Improvement Advice</h3>
                <ul className="space-y-2">
                  {(result.advice || []).map((item, i) => (
                    <li key={i} className="text-gray-700">• {item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <button onClick={() => navigate('/tools/jd-match')} className="flex-1 bg-gray-900 hover:bg-gray-800 text-white font-bold py-4 rounded-xl transition-all">
              Continue To JD Matching
            </button>
            <button onClick={() => navigate('/tools/fixer')} className="flex-1 border border-gray-300 hover:border-blue-500 text-gray-700 font-bold py-4 rounded-xl transition-all">
              Improve Resume Bullets
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AtsResult;
